import { PropType } from 'vue';
import { Options, Vue } from 'vue-class-component';

@Options({
  name: 'TabsEnumFilter',
  props: {
    enumTabs: {
      required: true,
    },
    selectedTab: {
      required: true,
    },
    hiddenTabs: {
      required: false,
      default: [],
    },
  },
  emits: ['select-tab'],
})
export default class TabsEnumFilter<T> extends Vue {
  enumTabs!: T;
  selectedTab!: keyof T;
  hiddenTabs!: [];

  get enumProps() {
    return Object.keys(this.enumTabs).reduce((t: any, v) => {
      const p = this.enumTabs[v as keyof T];
      if (isNaN(+p)) t[p] = v;
      return t;
    }, {});
  }

  selectTab(value: keyof T) {
    this.$emit('selectTab', value);
  }

  isTabShown(a: any) {
    return !this.hiddenTabs.some((k) => k == a);
  }
}
